import {
  InternalLinkItem,
  type InternalLinkItemProps,
} from '~/modules/link-farm/components/LinkList/InternalLinkItem';
import type { LinkItemProps } from '~/modules/link-farm/components/LinkList/LinkItem.tsx';
import { LinkItem } from '~/modules/link-farm/components/LinkList/LinkItem.tsx';

import type { InternalLinkType } from '../../types';

interface LinkListProps {
  data: (LinkItemProps | InternalLinkItemProps)[];
  onInternalLinkClick?: (
    event: React.MouseEvent<HTMLAnchorElement>,
    type?: InternalLinkType,
  ) => void;
}

export function LinkList({ data, onInternalLinkClick }: LinkListProps) {
  return (
    <div className="grid w-full auto-rows-min grid-cols-auto-fill-19 gap-md overflow-auto overscroll-contain">
      {data.map((item) => {
        const isInternal = 'previewImgSrc' in item;

        return isInternal ? (
          <InternalLinkItem
            key={item.actionTextKey}
            {...item}
            onClick={onInternalLinkClick}
          />
        ) : (
          <LinkItem key={item.actionText + item.url} {...item} />
        );
      })}
    </div>
  );
}

LinkList.displayName = 'LinkList';
